module.exports = __webpack_public_path__ + "img/aktsomhet.a6a01777.jpg";